const apiUrl = process.env.REACT_APP_API_URL;

const toArray = (j) =>
    Array.isArray(j) ? j
        : Array.isArray(j?.data) ? j.data
            : Array.isArray(j?.result) ? j.result
                : [];

//--------------------------------Status------------------------------------------------
export const getRoles = async () => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/getRoles`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };
    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return []
    }
}

export const addStatus = async (name) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/addStatus`;
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            name
        })
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return { result: false }
    }
}

export const getStatuses = async () => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/getStatuses`;
    try {
        const res = await fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        });
        if (!res.ok) return [];
        const j = await res.json();
        return toArray(j);
    } catch (e) {
        return [];
    }
};

export const getStatusById = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/getStatusById/${id}`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return {}
    }
}

export const updateStatus = async (id, name, isActive) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/updateStatus`;
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            id, name, isActive
        })
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return {}
    }
}

export const deleteStatus = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/deleteStatus/${id}`;
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return {}
    }
}

//--------------------------------Units Measures------------------------------------------------
export const addUnitMeasure = async (name) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/addUnitMeasure`;
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            name
        })
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return { result: false }
    }
}

export const getUnitMeasures = async () => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/getUnitsMeasures`;
    try {
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        if (!res.ok) return [];
        const j = await res.json();
        return toArray(j);
    } catch (e) {
        return [];
    }
}

export const getUnitMeasureById = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/getUnitMeasureById/${id}`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return {}
    }
}

export const updateUnitMeasure = async (id, name, abbreviation, isActive) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/updateUnitMeasure`;
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            id, name, abbreviation, isActive
        })
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return {}
    }
}

export const deleteUnitMeasure = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/deleteUnitMeasure/${id}`;
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    }
    catch (error) {
        return {}
    }
}